import { EMPTY, Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { AuthService } from 'src/app/core';
import { AuthInnerRouterParams } from 'src/app/core/components';

@Injectable({
  providedIn: 'root',
})
export class LandingAuthBoxService {
  private _action$: Subject<AuthInnerRouterParams> = new Subject();

  constructor(private authService: AuthService) {}

  get action$() {
    return this._action$.pipe(catchError(() => EMPTY));
  }

  public open(id?: AuthInnerRouterParams) {
    this._action$.next(id!);
  }

  public close(id?: AuthInnerRouterParams) {
    this._action$.next(id!);
  }

  async isLoggedIn(): Promise<boolean> {
    return await this.authService.isLoggedIn();
  }
}
